import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import { VIEW_DETAILS_COMMON_KEYS, VIEW_SI_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function SIDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <Row xs={12}>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_SI_DETAILS_KEYS.SENDER_ACCOUNT_NO)}</label>
        <span>{option?.srcAccount || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.SENDER_BARNCH)}</label>
        <span>{option?.srcAccBranch || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.SENDER_CURRENCY)}</label>
        <span>{option?.srcAccCcy || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.AMOUNT)}</label>
        <span>
          <NumberFormat
            value={option?.amount}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </span>
        <label>{t(VIEW_SI_DETAILS_KEYS.TRANSFER_TYPE)}</label>
        <span>{option?.transferType || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.ADDRESS)}</label>
        <span>{option?.address || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.BANK_CODE)}</label>
        <span>{option?.bankCode || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        {option?.monthEndFlag === 'Y' && (
          <>
            <label>{t(VIEW_SI_DETAILS_KEYS.MONTH_END)}</label>
            <span>{'Yes'}</span>
          </>
        )}

        {option?.monthEndFlag === 'N' && (
          <>
            <Row xs={'12'}>
              <Col xs={'4'} sm={'4'} md={'4'}>
                <label>{t(VIEW_SI_DETAILS_KEYS.DAYS)}</label>
                <span>{option?.days || '-'}</span>
              </Col>
              <Col xs={'4'} sm={'4'} md={'4'}>
                <label>{t(VIEW_SI_DETAILS_KEYS.MONTHS)}</label>
                <span>{option?.months || '-'}</span>
              </Col>
              <Col xs={'4'} sm={'4'} md={'4'}>
                <label>{t(VIEW_SI_DETAILS_KEYS.YEARS)}</label>
                <span>{option?.years || '-'}</span>
              </Col>
            </Row>
          </>
        )}
      </Col>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_SI_DETAILS_KEYS.RECEIVER_ACCOUNT_NO)}</label>
        <span>{option?.destAccount || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.RECEIVER_BARNCH)}</label>
        <span>{option?.destAccBranch || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.RECEIVER_CURRENCY)}</label>
        <span>{option?.destAccCcy || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.RECEIVER_NAME)}</label>
        <span>{option?.destAccName || '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.EXPIRY_DATE)}</label>
        <span>{option?.expireDate !== null ? option?.expireDate : '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.FIRST_VALUE_DATE)}</label>
        <span>{option?.firstValDate !== null ? option?.firstValDate : '-'}</span>
        <label>{t(VIEW_SI_DETAILS_KEYS.REMARKS)}</label>
        <span>{option?.remarks || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
